import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getContent } from '../services/contentService';
import ReactMarkdown from 'react-markdown';

const EducationalPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (slug) {
      getContent(slug).then(data => {
        setContent(data);
        setLoading(false);
      });
    }
  }, [slug]);

  if (loading) return <div className="p-8 text-center">در حال بارگذاری...</div>;

  return (
    <div className="container mx-auto p-8 max-w-4xl">
      <div className="markdown-body">
        <ReactMarkdown>{content || 'محتوایی یافت نشد.'}</ReactMarkdown>
      </div>
    </div>
  );
};

export default EducationalPage;
